'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.magazine.popup', []);

_module.directive('popupV1', popupV1);

exports.default = _module;


function popupV1() {
    return {
        restrict: 'A',
        scope: true,
        controller: ['$element', '$window', '$attrs', function controller($element, $window, $attrs) {
            var vm = this;
            var defaultSettings = {
                width: 1000,
                height: 700,
                left: 24,
                top: 24,
                scrollbars: 'yes',
                resizable: 'yes',
                newTabOnMobile: true
            };
            var href = $attrs.href ? $attrs.href : '';
            var a = new RegExp('/' + window.location.host + '/');
            var isExternal = !a.test(this.href);
            var isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;

            if (href && isExternal) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (isMobile && defaultSettings.newTabOnMobile) {
                        var popup = window.open(href, '_blank');
                        popup.focus();
                    } else {
                        var _popup = window.open(href, '_blank', 'width=' + defaultSettings.width + ', height=' + defaultSettings.height + ', left=' + defaultSettings.left + ', top=' + defaultSettings.top + ', scrollbars=' + defaultSettings.scrollbars + ', resizable=' + defaultSettings.resizable);
                        _popup.focus();
                    }
                });
            }
        }]
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/magazine/popup/popup.directive.js
// module id = 842
// module chunks = 0